import React, { ChangeEvent } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "var(--dmg-bg)",
    // "input:hover ~ &": {
    //   backgroundColor: "transparent",
    // },
    "input:disabled ~ &": {
      boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    },
  },
  checkedIcon: {
    backgroundColor: "var(--dmg-purple)",
    boxShadow: "none",
    backgroundImage: "",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      opacity: 0.9,
    },
  },
});

function StyledCheckbox(props: CheckboxProps) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

interface CustomizedCheckbox {
  id?: string;
  name?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>, data?: any) => void;
  value?: unknown;
}

export default function CustomizedCheckbox(props: CustomizedCheckbox) {
  const { id, name, disabled, checked, value, onChange } = props;
  return (
    <StyledCheckbox
      id={id}
      defaultChecked={checked}
      name={name}
      disabled={disabled}
      onChange={onChange}
      value={value}
    />
  );
}
